import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevModeService {

  private static readonly STORAGE_KEY = 'dexcarga.devMode';

  private readonly _enabled$ = new BehaviorSubject<boolean>(false);
  readonly enabled$: Observable<boolean> = this._enabled$.asObservable();

  get isAvailable(): boolean {
    return !environment.production;
  }

  get isEnabled(): boolean {
    return this.isAvailable && this._enabled$.value;
  }

  setupListeners() {
    if (!this.isAvailable) return;

    const persisted = localStorage.getItem(DevModeService.STORAGE_KEY) === 'true';
    this._enabled$.next(persisted);

    const service = this;
    (window as any).devMode = {
      enable: () => service.enable(),
      disable: () => service.disable(),
      toggle: () => service.toggle(),
      get isEnabled() { return service.isEnabled; }
    };
  }

  enable() {
    if (!this.isAvailable) return;
    this.persist(true);
  }

  disable() {
    if (!this.isAvailable) return;
    this.persist(false);
  }

  toggle() {
    if (!this.isAvailable) return;
    this.isEnabled ? this.disable() : this.enable();
  }

  removeListeners() {
    delete (window as any).devMode;
  }

  private persist(value: boolean) {
    localStorage.setItem(DevModeService.STORAGE_KEY, String(value));
    this._enabled$.next(value);
  }
}
